import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f743dd24"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-center mt-3 d-flex flex-column align-items-center" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = {
  key: 1,
  href: "#"
}
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = {
  key: 3,
  class: "mt-3 activity-row"
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "d-flex flex-column align-items-center" }
const _hoisted_8 = { class: "fa-stack fa-lg" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "activity-label" }, "Watch", -1))
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "d-flex flex-column align-items-center" }
const _hoisted_12 = { class: "fa-stack fa-lg" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "activity-label" }, "Read", -1))
const _hoisted_14 = { key: 2 }
const _hoisted_15 = { class: "d-flex flex-column align-items-center" }
const _hoisted_16 = { class: "fa-stack fa-lg" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "activity-label" }, "Quiz", -1))
const _hoisted_18 = { key: 3 }
const _hoisted_19 = ["href"]
const _hoisted_20 = { class: "d-flex flex-column align-items-center" }
const _hoisted_21 = { class: "fa-stack fa-lg" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "activity-label" }, "Glossary", -1))
const _hoisted_23 = { key: 4 }
const _hoisted_24 = ["href"]
const _hoisted_25 = { class: "d-flex flex-column align-items-center" }
const _hoisted_26 = { class: "fa-stack fa-lg" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "activity-label" }, "Activities", -1))
const _hoisted_28 = {
  key: 5,
  class: "col-lg"
}
const _hoisted_29 = ["href"]
const _hoisted_30 = { class: "d-flex flex-column align-items-center" }
const _hoisted_31 = { class: "fa-stack fa-lg" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "activity-label" }, "Parent Guide", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_lesson_sticker = _resolveComponent("lesson-sticker")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.lesson.id && _ctx.lesson.id > 0)
      ? (_openBlock(), _createBlock(_component_router_link, {
          key: 0,
          to: {
                name: _ctx.routeNames.lesson,
                params: {
                    courseId: _ctx.lesson.courseId,
                    lessonId: _ctx.lesson.id
                }
            }
        }, {
          default: _withCtx(() => [
            (_ctx.imageUrl)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  class: "img-fluid",
                  src: _ctx.imageUrl,
                  alt: _ctx.lesson.name + ' Lesson Thumbnail'
                }, null, 8, _hoisted_2))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["to"]))
      : (_openBlock(), _createElementBlock("a", _hoisted_3, [
          (_ctx.imageUrl)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                class: "img-fluid",
                src: _ctx.imageUrl,
                alt: _ctx.lesson.name + ' Lesson Thumbnail',
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleClick && _ctx.handleClick(...args))),
                onKeypress: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleClick && _ctx.handleClick(...args)))
              }, null, 40, _hoisted_4))
            : _createCommentVNode("", true)
        ])),
    (!_ctx.isParent && _ctx.lesson.id && _ctx.lesson.id > 0)
      ? (_openBlock(), _createBlock(_component_lesson_sticker, {
          key: 2,
          "lesson-id": _ctx.lesson.id ?? 0,
          class: "mt-3"
        }, null, 8, ["lesson-id"]))
      : _createCommentVNode("", true),
    (_ctx.lesson.id && _ctx.lesson.id > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_ctx.lesson.hasVideo)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(_component_router_link, {
                  to: {
                        name: _ctx.routeNames.lesson,
                        params: {
                            courseId: _ctx.lesson.courseId,
                            lessonId: _ctx.lesson.id
                        },
                        hash: _ctx.routeHashes.video
                    }
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createVNode(_component_font_awesome_icon, {
                          icon: "circle",
                          class: "fa-stack-2x text-theme"
                        }),
                        _createVNode(_component_font_awesome_icon, {
                          icon: "play",
                          class: "fa-stack-1x text-white"
                        })
                      ]),
                      _hoisted_9
                    ])
                  ]),
                  _: 1
                }, 8, ["to"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.lesson.hasBook)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createVNode(_component_router_link, {
                  to: {
                        name: _ctx.routeNames.lesson,
                        params: {
                            courseId: _ctx.lesson.courseId,
                            lessonId: _ctx.lesson.id
                        },
                        hash: _ctx.routeHashes.eBook
                    }
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _createVNode(_component_font_awesome_icon, {
                          icon: "circle",
                          class: "fa-stack-2x text-theme"
                        }),
                        _createVNode(_component_font_awesome_icon, {
                          icon: "book-reader",
                          class: "fa-stack-1x text-white"
                        })
                      ]),
                      _hoisted_13
                    ])
                  ]),
                  _: 1
                }, 8, ["to"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.lesson.hasQuiz && !_ctx.isParent)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createVNode(_component_router_link, {
                  to: {
                        name: _ctx.routeNames.lesson,
                        params: {
                            courseId: _ctx.lesson.courseId,
                            lessonId: _ctx.lesson.id
                        },
                        hash: _ctx.routeHashes.quiz
                    }
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _createVNode(_component_font_awesome_icon, {
                          icon: "circle",
                          class: "fa-stack-2x text-theme"
                        }),
                        _createVNode(_component_font_awesome_icon, {
                          icon: "pencil-ruler",
                          class: "fa-stack-1x text-white"
                        })
                      ]),
                      _hoisted_17
                    ])
                  ]),
                  _: 1
                }, 8, ["to"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.lesson.lessonSummaryFileUrl)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _createElementVNode("a", {
                  href: _ctx.lesson.lessonSummaryFileUrl,
                  target: "_blank"
                }, [
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      _createVNode(_component_font_awesome_icon, {
                        icon: "circle",
                        class: "fa-stack-2x text-theme"
                      }),
                      _createVNode(_component_font_awesome_icon, {
                        icon: "book-open",
                        class: "fa-stack-1x text-white"
                      })
                    ]),
                    _hoisted_22
                  ])
                ], 8, _hoisted_19)
              ]))
            : _createCommentVNode("", true),
          (_ctx.lesson.activityFileUrl)
            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                _createElementVNode("a", {
                  href: _ctx.lesson.activityFileUrl,
                  target: "_blank"
                }, [
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                      _createVNode(_component_font_awesome_icon, {
                        icon: "circle",
                        class: "fa-stack-2x text-theme"
                      }),
                      _createVNode(_component_font_awesome_icon, {
                        icon: "gamepad",
                        class: "fa-stack-1x text-white"
                      })
                    ]),
                    _hoisted_27
                  ])
                ], 8, _hoisted_24)
              ]))
            : _createCommentVNode("", true),
          (_ctx.isParent && _ctx.lesson.parentsGuideFileUrl)
            ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                _createElementVNode("a", {
                  href: _ctx.lesson.parentsGuideFileUrl,
                  target: "_blank"
                }, [
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("div", _hoisted_31, [
                      _createVNode(_component_font_awesome_icon, {
                        icon: "circle",
                        class: "fa-stack-2x text-theme"
                      }),
                      _createVNode(_component_font_awesome_icon, {
                        icon: "clipboard",
                        class: "fa-stack-1x text-white"
                      })
                    ]),
                    _hoisted_32
                  ])
                ], 8, _hoisted_29)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}